
import React from "react";
import AdminPageBase from "@/components/admin/AdminPageBase";
import ExpertApplicationsContainer from "@/components/admin/expert-applications/ExpertApplicationsContainer";
import { useExpertApplicationsLogic } from "@/hooks/useExpertApplicationsLogic";

export default function ExpertApplicationsPage() {
  const { handleManualRefresh, isLoading } = useExpertApplicationsLogic();

  return (
    <AdminPageBase
      title="Expert Applications Management"
      description="Comprehensive review and management of expert marketplace applications"
      onRefresh={handleManualRefresh}
      loading={isLoading}
    >
      <ExpertApplicationsContainer />
    </AdminPageBase>
  );
}
